import http from "@/plugins/http";

export const state = {
  auditLogs: [],
  authLogs: []
};

export const getters = {
  auditLogs: state => {
    return state.auditLogs;
  },
  authLogs: state => {
    return state.authLogs;
  }
};

export const mutations = {
  SET_AUDIT_LOGS(state, data) {
    state.auditLogs = data;
  },
  SET_AUTH_LOGS(state, data) {
    state.authLogs = data;
  }
};

export const actions = {
  async getAuditLogs({ commit, dispatch, rootState }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let logs = await http.get(
        `visp/GetServiceHistoryById/${rootState.service.available.radiusServiceId}`
      );
      commit("SET_AUDIT_LOGS", logs.data.data.entries);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getAuthLogs({ commit, dispatch, rootState }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let logs = await http.get(
        `visp/GetAuthLogs/${rootState.service.available.radiusServiceId}`
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      //commit("SET_AUTH_LOGS", logs.data.data);
      return Promise.resolve(logs.data.data)
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  }
};
